<template>
  <div id="app" class="bg-dak">
    <nav class="navbar navbar-expand-xl navbar-dark bg-dark">
      <router-link :to="{name: 'home'}" class="navbar-brand">
        <img src="/assets/logo.png" height="40px" style="margin-right: 2px"> Panel Lidera
      </router-link>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarMenu" aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarMenu">
        <ul class="navbar-nav mr-auto cubic">
          <li class="nav-item">
            <router-link v-if="currentUser && currentUser.isAdmin" :to="{name: 'admin'}" class="nav-link">
              <font-awesome-icon icon="tachometer-alt"/> Administrator
            </router-link>
          </li>

          <li class="nav-item">
            <router-link v-if="currentUser && premiumChannel && isEnabled('manageGroup')" :to="{name: 'manageGroup'}" class="nav-link">
                <font-awesome-icon icon="cog"/> Grupa
            </router-link>
          </li>
          <li class="nav-item">
            <router-link v-if="currentUser && premiumChannel && isEnabled('clients')" :to="{name: 'clients'}" class="nav-link">
              <font-awesome-icon icon="users"/> Klienci
            </router-link>
          </li>
          <li class="nav-item">
            <router-link v-if="currentUser && premiumChannel && isEnabled('manageChannels')" :to="{name: 'manageChannels'}" class="nav-link">
              <font-awesome-icon icon="sitemap"/> Kanały
            </router-link>
          </li>
          <li class="nav-item">
            <router-link v-if="currentUser && premiumChannel && isEnabled('announcements')" :to="{name: 'announcements'}" class="nav-link">
              <font-awesome-icon icon="bullhorn"/> Ogłoszenia
            </router-link>
          </li>
          <li class="nav-item">
            <router-link v-if="currentUser && premiumChannel && isEnabled('teleport')" :to="{name: 'teleport'}" class="nav-link">
              <font-awesome-icon icon="fighter-jet"/> Teleport
            </router-link>
          </li>
          <li class="nav-item">
            <router-link v-if="currentUser && premiumChannel && isEnabled('premiumPokes')" :to="{name: 'premiumPokes'}" class="nav-link">
              <font-awesome-icon icon="hand-point-right"/> Zaczepki
            </router-link>
          </li>
          <li class="nav-item" v-if="currentUser && premiumChannel && currentUser.isOwner && isEnabled('access')">
            <router-link v-if="currentUser" :to="{name: 'access'}" class="nav-link">
              <font-awesome-icon icon="user"/> Dostęp do panelu
            </router-link>
          </li>
        </ul>

        <ul v-if="!currentUser" class="navbar-nav ml-auto">
          <li class="nav-item">
              <a href="https://faq.beastcore.eu/vip/" target="_blank" class="nav-link">
                <font-awesome-icon icon="question"/> FAQ
              </a>
          </li>
          <li class="nav-item">
            <router-link :to="{name: 'login'}" class="nav-link">
              <font-awesome-icon icon="sign-in-alt"/> Zaloguj
            </router-link>
          </li>
        </ul>

        <ul v-if="currentUser" class="navbar-nav ml-auto">
          <li class="nav-item">
            <a href="https://faq.beastcore.eu/vip/" target="_blank" class="nav-link">
              <font-awesome-icon icon="question"/> FAQ
            </a>
          </li>
          <li class="nav-item">
            <router-link :to="{name: 'profile'}" class="nav-link">
              <font-awesome-icon icon="user" />
              {{ currentUser.clientNick }}
            </router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link" href @click.prevent="logOut">
              <font-awesome-icon icon="sign-out-alt"/> Wyloguj
            </a>
          </li>
        </ul>
      </div>
    </nav>


    <div class="page-content">
      <router-view />
    </div>


    <footer id="sticky-footer" class="py-4 bg-dark text-white-50">
      <div class="text-center" style="padding-left: 20px; padding-right: 20px;">
        <small>Copyright &copy; <a href="http://ro-bot.net" target="_blank">RO-BOT.net</a> Panel Lidera</small>
        <small class="float-right theme-switcher" style="cursor: pointer" @click="switchTheme"><font-awesome-icon icon="paint-brush" class="mr-1"/> Zmień styl</small>
      </div>
    </footer>

  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    data() {
      return {
        dark: false,
      };
    },
    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
      premiumChannel() {
        return this.$store.state.auth.premiumChannel;
      },
      pagesEnabled() {
        return this.$store.state.auth.pagesEnabled;
      },
    },
    created() {
      let body = document.querySelector("body");

      body.classList.add('preload');

      if (Vue.$cookies.isKey('theme-style-dark'))
        this.dark = Vue.$cookies.get('theme-style-dark') == 'true' ? true : false;
      else
        this.dark = true;

      this.dark = !this.dark;
      this.switchTheme();
    },
    methods: {
      isEnabled(name) {
        return !(this.pagesEnabled && typeof this.pagesEnabled[name] !== 'undefined' && this.pagesEnabled[name] === false);
      },
      logOut() {
        this.$store.dispatch('auth/logout');
        this.$router.push({name: 'login'});
      },
      setUpTheme() {
        let theme = this.dark ? 'dark' : 'light';

        let custom = document.querySelector("#custom-style");
        if (custom) {
          let parentNode = custom.parentNode;
          parentNode.removeChild(custom);
        }

        let el = document.createElement("link");
        el.setAttribute("rel", "stylesheet");
        el.setAttribute("href", "/assets/css/" + theme + ".css");
        el.setAttribute("id", "theme-style-" + theme);
        document.querySelector("head").append(el);

        custom = document.createElement("link");
        custom.setAttribute("rel", "stylesheet");
        custom.setAttribute("href", "/assets/css/custom.css");
        custom.setAttribute("id", "custom-style");
        document.querySelector("head").append(custom);
      },
      removeTheme() {
        let theme = !this.dark ? 'dark' : 'light';
        let el = document.querySelector("#theme-style-" + theme);

        if (el) {
          let parentNode = el.parentNode;
          parentNode.removeChild(el);
        }
      },
      switchTheme() {
        this.dark = !this.dark;
        window.CURRENT_THEME_DARK = this.dark;
        Vue.$cookies.set('theme-style-dark', this.dark);
        this.setUpTheme();
        setTimeout(this.removeTheme, 200);
      }
    }
  };
</script>

<style>
  .page-content {
    padding: 40px 20px 60px 20px;
  }

  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 40px;
    line-height: 00px;
    background-color: #f5f5f5;
    z-index: 3001;
  }

  label {
    display: block;
    margin-top: 10px;
  }

  footer a {
    color: rgba(255,255,255,.5)!important;
  }

  .theme-switcher {
    margin-top: -5px;
  }
</style>